<template>

<div>

    <div class="row">
        <div :class="[ 'col-lg-3 project-timeline-holder', { 'slide' : isOpen } ]">
            <phase-sidebar v-if='isReady && sidebarActive'></phase-sidebar>
        </div>

        <div v-if='!isReady' class="d-flex justify-content-center">
            <img src='/resources/loader.svg'>
        </div>

        <div class="col-lg-9">
            <div class="row">
                <div class="col-12 text-center btn-timeline-wrap">
                    <button id="btn-timeline" class="btn btn-outline-secondary mt-5 mb-3" @click="isOpen = !isOpen">
                        <span class="icon icon-flag"></span>
                        Етапи на проекта
                    </button>
                </div>
            </div>
            
            <div v-if='isReady'>

                <project-header v-if='page != "form"'></project-header>
                <project-page   v-if='page == "index"'></project-page>
                <project-files  v-if='page == "files"' :pid='p'></project-files>
                <project-phase  v-if='page == "phase" && phaseReady'></project-phase>
                <project-static  v-if='page == "static"'></project-static>
                <project-finish  v-if='page == "project-finish"'></project-finish>
                <project-tp  v-if='page == "project-tp"'></project-tp>
                <project-messages v-if='page == "messages"' :conf='msgConfig'></project-messages>

            </div>
 
        </div>

    </div> 

</div>

</template>

<script>
    export default {
        mounted() {
            this.getData();

            $("body").addClass('project-record');

            var me = this;
            
            bus.$on('update-phase', ( ph ) => {
                me.updatePhase( ph );
            })

            bus.$on('refresh-page', () => {
                me.refreshSidebar();
            })
        },

        destroyed() {
            $("body").removeClass('project-record');
        },

        created() {

            this.setBcLinks([ { name : 'Проекти', url : 'projects' } ]);

        },

        props : ['p'],

        data() {
            return {

                bcLinks : [
                    { name : 'Проекти', url : 'projects' }
                ],

                isLoading   : false,
                isReady     : false,
                isOpen      : false,

                model   : false,
                page    : "index",
                phase   : false,
                pages   : ['files','messages','index','project-tp'],

                messages : 0,
                files    : 0,

                sidebarActive : true,

                styles : [],
                projectStyles : [],

                projectPhase : false,
                phaseReady : false,

                msgConfig : {
                    owner_id : null
                }

            }
        },

        methods : {

            setPage( p, resetPhase ) {

                if( resetPhase ) {
                    this.phase = false;
                    this.projectPhase = false;
                }

                this.page = p;
                
                if(this.isOpen == true) {
                    this.isOpen = false;
                }

                if( p != 'phase' ) {
                    location.hash = p;
                }

                this.navigate('top',300);
            },

            /*
             * Open a phase page. Auction and contest Index.vue files can
                now use "this.$parent.phase" and "this.$parent.projectPhase" 
                to access the phase and project data for it.

             */
            setPhase( phase, projectPhase ) {
                this.phaseReady = false;
                this.phase = phase;
                this.projectPhase = projectPhase;

                this.setPage('phase');

                var me = this;

                this.$nextTick( () => {
                    me.phaseReady = true;
                });

            },

            resetPhase() {
                this.setPhase( this.phase, false );
            },

            //When a project phase has changed
            updatePhase( phase ) {
                
                this.phaseReady = false;

                if( typeof phase == 'undefined' ) {

                    this.projectPhase = Object.assign({}, this.projectPhase);

                } else {

                    this.projectPhase = Object.assign({}, this.projectPhase, phase);
                    
                }

                var me = this;

                this.setPage('phase');
                this.refreshSidebar();

                this.$nextTick( () => {
                    me.phaseReady = true;
                });
            },


            refreshSidebar() {
                this.sidebarActive = false;
                this.isReady = false;

                var me = this;

                this.$nextTick( () => {
                    me.sidebarActive = true;
                    me.isReady = true;
                })
            },

            getData() {
                var me = this;

                me.ajax.call('prj:grd', { id : this.p }, (r) => {
                    
                    if( r.status == 'success' ) {

                        me.model        = r.data.project;
                        me.messages     = r.data.m;
                        me.files        = r.data.f;
                        me.styles       = r.data.s;

                        me.msgConfig.owner_id = me.model.user_id;

                        me.$store.state.isOwner = me.model.user_id == me.user.id;

                        me.pushBcLink({
                            name : me.model.name ,
                            url  : ''
                        });

                        me.checkPage();

                        me.isReady = true;

                    }

                })
            },

            checkPage() {
                var h = location.hash;

                if( h ) {
                    h = h.replace('#','');
                }

                if( h.includes('project-tp-') ) {

                    h = 'project-tp';                    

                }

                //Static page
                if( h && this.pages.includes(h) ) {

                    this.page = h.replace('#','');

                }
            }
        },

        components : {
            'phase-sidebar'     : require('./PhaseSidebar.vue').default,
            'project-messages'  : require('./Messages.vue').default,
            'project-files'     : require('./Files.vue').default,
            'project-page'      : require('./Page.vue').default,
            'project-header'    : require('./Header.vue').default,
            'project-phase'     : require('./Phase/Index.vue').default,
            'project-tp'        : require('./Phase/TP/Index.vue').default,
            'project-finish'    : require('./Finish.vue').default,
            'project-static'    : require('./ProjectStatic.vue').default,

        }
    }
</script>
